import { StyledDropdownItemButton } from "./Button/DropdownItemButton.styles";

export const DropdownItem = {
    Button: StyledDropdownItemButton,
};
